import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Calendar } from 'lucide-react';
import { PRESETS, calcDatePreset } from './DateRangePicker';

const CUSTOM_VALUE = 'custom';

/**
 * DateRangeSelect - Bản gọn của DateRangePicker: 1 dropdown chọn preset thay vì
 * render hết các nút bấm cùng lúc. Chỉ hiện 2 ô ngày khi chọn "Tuỳ chỉnh".
 * @param {string} fromDate - Ngày bắt đầu YYYY-MM-DD
 * @param {string} toDate - Ngày kết thúc YYYY-MM-DD
 * @param {function} onChange - Callback(from: string, to: string) khi thay đổi
 * @param {string} defaultPreset - Preset mặc định khi khởi tạo ('today', 'last7days', ...)
 */
const DateRangeSelect = ({ fromDate, toDate, onChange, defaultPreset = 'thisMonth' }) => {
  const [preset, setPreset] = useState(defaultPreset || CUSTOM_VALUE);

  const handlePresetChange = (e) => {
    const value = e.target.value;
    setPreset(value);
    if (value !== CUSTOM_VALUE) {
      const { from, to } = calcDatePreset(value);
      onChange(from, to);
    }
  };

  const handleFromChange = (e) => onChange(e.target.value, toDate);
  const handleToChange = (e) => onChange(fromDate, e.target.value);

  return (
    <Row className="g-2 align-items-end">
      <Col md={preset === CUSTOM_VALUE ? 4 : 6}>
        <Form.Label>
          <Calendar size={16} className="me-1" />
          Khoảng thời gian
        </Form.Label>
        <Form.Select size="sm" value={preset} onChange={handlePresetChange}>
          {PRESETS.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
          <option value={CUSTOM_VALUE}>Tuỳ chỉnh</option>
        </Form.Select>
      </Col>
      {preset === CUSTOM_VALUE ? (
        <>
          <Col md={4}>
            <Form.Label>Từ ngày</Form.Label>
            <Form.Control type="date" size="sm" value={fromDate} onChange={handleFromChange} />
          </Col>
          <Col md={4}>
            <Form.Label>Đến ngày</Form.Label>
            <Form.Control type="date" size="sm" value={toDate} onChange={handleToChange} />
          </Col>
        </>
      ) : (
        <Col
          md={6}
          className="pb-2"
        >
          <small className="text-muted">
            {fromDate} – {toDate}
          </small>
        </Col>
      )}
    </Row>
  );
};

export default DateRangeSelect;
